var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.04 11.3623C18.04 10.9223 17.7035 10.5859 17.2635 10.5859C16.8235 10.5859 16.487 10.9223 16.487 11.3623C16.487 14.3906 14.0282 16.8494 11 16.8494C7.97173 16.8494 5.5129 14.3906 5.5129 11.3623C5.5129 10.9223 5.17643 10.5859 4.73643 10.5859C4.29643 10.5859 3.95996 10.9223 3.95996 11.3623C3.95996 14.96 6.65173 17.9882 10.2235 18.3765V20.4471H7.40231C6.96231 20.4471 6.62584 20.7835 6.62584 21.2235C6.62584 21.6635 6.96231 22 7.40231 22H14.5976C15.0376 22 15.3741 21.6635 15.3741 21.2235C15.3741 20.7835 15.0376 20.4471 14.5976 20.4471H11.7764V18.3765C15.3482 17.9882 18.04 14.96 18.04 11.3623Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 0C8.61891 0 6.67773 1.94118 6.67773 4.32235V11.3365C6.67773 13.7435 8.61891 15.6588 11.0001 15.6847C13.3813 15.6847 15.3225 13.7435 15.3225 11.3624V4.32235C15.3225 1.94118 13.3813 0 11.0001 0Z",
    fill: "#4B9BF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.95298fddc93262a38670b4d73e214a35.svg";
export { ForwardRef as ReactComponent };